import { AppBar } from '@horof/shared';
import { createBrowserRouter, Outlet, ScrollRestoration } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { HELP } from './help';
import { MeterPage } from './MeterPage';
import { RoundPage } from './RoundPage';
import { RoundStateProvider } from './round-state';

function Layout() {
  return (
    <RoundStateProvider>
      <ScrollRestoration />
      <AppBar help={HELP} />
      <Outlet />
    </RoundStateProvider>
  );
}

const router = createBrowserRouter(
  [
    {
      element: <Layout />,
      children: [
        { path: '/', element: <RoundPage /> },
        { path: '/meter/:meterId', element: <MeterPage /> },
      ],
    },
  ],
  { basename: import.meta.env.BASE_URL },
);

export function App() {
  return <RouterProvider router={router} />;
}
